<script>

  export default{
    name : 'CpAccountInviteDialog',
    components : {
      CpDialog : require('../dialog').default,
      CpAuthForm : require('../auth-form/index').default,
      CpBox: require('../box').default,
      CpBoxContent: require('../box-content').default,
      CpGrid: require('../grid').default,
      CpGridItem: require('../grid-item').default,
      CpButton: require('../button').default,
    },
    props : {
      invitingUser : Object,
    },
    data(){
      return{
        showDialog : true,
        appUrl: process.env.MIX_APP_URL,
      }
    }
  }
</script>

<template>
  <cp-dialog v-if="showDialog" style="padding:20px;" class="account-invite-dialog">
    <svg @click.prevent="showDialog=!showDialog" class="close-svg-icon" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z" />
    </svg>
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;padding:30px;">
      <img :src="invitingUser.profile_image" style="max-width:100px; border-radius:50%;border: 1px solid #eee;"/>
      <h2 class="heading-1">{{invitingUser.first_name }} {{invitingUser.last_name }}</h2>
      <h2 class="heading-4" style="margin-bottom:0px;">Wants you to join CrowdBlue! <br> The social network for politics.</h2>
      <cp-auth-form :show-form-title="false" :show-sign-up="true" :return-url="`${appUrl}/feed`" login-type="return_url" />
    </div>
  </cp-dialog>
</template>


<style>

.account-invite-dialog{

}

</style>
